import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Salutation } from './salutation.interface';
import { SalutationService } from './salutation.service';

const service = new SalutationService();

export interface SalutationState {
   salutations: Array<Salutation>;
}

const SalutationStore: Module<SalutationState, StoreState> = {
   namespaced: true,
   state: {
      salutations: [],
   },
   getters: {},
   mutations: {
      SET_SALUTATIONS(state, salutations: Array<Salutation>) {
         state.salutations = salutations;
      },
   },
   actions: {
      async getSalutations(context, query?: LocationQuery) {
         const response = await service.getSaltutations(query);
         context.commit('SET_SALUTATIONS', response);
         return response;
      },
   },
};

export default SalutationStore;
